var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"grid-x align-stretch grid",class:_vm.gridCssClass},[_vm._l((_vm.record.cards),function(card){return [_vm._t("default",null,{"card":card,"breakpoint":_vm.media})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }